import { verifyMethods } from '@/utils/tools.js';

export const limitCountText = (item) => {
  let str = '';
  if (item.limit_count.min && item.limit_count.max) {
    str = `只能{{text1}} ${item.limit_count.min} ~ ${item.limit_count.max} {{text2}}`;
  }
  else if (!item.limit_count.min && item.limit_count.max) {
    str = `最多可{{text1}} ${item.limit_count.max} {{text2}}`;
    
  }
  else if (item.limit_count.min && !item.limit_count.max) {
    str = `最少需{{text1}} ${item.limit_count.min} {{text2}}`;
    
  }

  if (['text'].indexOf(item.type) >= 0) {
    str = str.replace('{{text1}}', '填写').replace('{{text2}}', '个字');
  }
  else if (['multi_select'].indexOf(item.type) >= 0) {
    str = str.replace('{{text1}}', '选择').replace('{{text2}}', '项');
  }
  else if (['image_upload'].indexOf(item.type) >= 0) {
    str = str.replace('{{text1}}', '上传').replace('{{text2}}', '张图片');
  }
  return str;
}

export const getVerificateText = (item, itemValue) => {
  let str = '';
  // 必填项
  if (item.required === 1) {
    
    if (['multi_select'].indexOf(item.type) >= 0) {
      if (!itemValue?.length) {
        str = '此为必填项';
      }
    }
    else if (['image_upload'].indexOf(item.type) >= 0) {
      if (!itemValue?.length) {
        str = '此为必填项';
      }
    }
    else if (['matrix_select'].indexOf(item.type) >= 0) {
      let hasVal = true;
      const rows = item.option.filter(v => v.type === 'matrix_row');
      rows.map(v => {
        if (!itemValue || !itemValue[v.id]) {
          hasVal = false;
        }
      });
      if (!hasVal) {
        str = '此为必填项';
      }
    }
    else {
      if (!itemValue) {
        str = '此为必填项';
      }
    }
  }
  if (str) {
    return str;
  }

  // 限制数量
  if (item.limit_count && itemValue?.length) {
    if (item.limit_count.min && item.limit_count.max) {
      if (itemValue?.length < item.limit_count.min || itemValue?.length > item.limit_count.max) {
        str = limitCountText(item);
      }
    }
    if (!item.limit_count.min && item.limit_count.max) {
      if (itemValue?.length > item.limit_count.max) {
        str = limitCountText(item);
      }
    }
    if (item.limit_count.min && !item.limit_count.max) {
      if (itemValue?.length < item.limit_count.min) {
        str = limitCountText(item);
      }
    }
    if (['multi_select'].indexOf(item.type) >= 0) {
      const optionIndex = item?.option?.findIndex(v => itemValue.indexOf(v.id) >= 0);
      if (optionIndex >= 0 && item?.option[optionIndex].special === 'all') {
        str = '';
      }
    }
  }
  if (str) {
    return str;
  }

  // 手机号验证
  if (item.type === 'phone' && itemValue) {
    if (item.phone_verify === 'number') {
      if (!verifyMethods.number(itemValue)) {
        str = '手机号仅限输入数字';
      }
    }
    else if (item.phone_verify === 'format') {
      if (!verifyMethods.phone(itemValue)) {
        str = '手机号格式不正确，请检查';
      }
    }
    else if (item.phone_verify === 'code') {
      if (!itemValue) {
        str = '请输入手机号';
      }
      else if (!verifyMethods.phone(itemValue)) {
        str = '手机号格式不正确，请检查';
      }
    }
  }
  if (str) {
    return str;
  }
  // 邮箱验证
  if (item.type === 'email' && itemValue) {
    if (!verifyMethods.email(itemValue)) {
      str = '邮箱格式不正确，请检查';
    }
  }
  if (str) {
    return str;
  }

  return str;
}